var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.688 3.75a1.563 1.563 0 1 0 0-3.126 1.563 1.563 0 0 0 0 3.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.785 11.547-1.187 6.727a.937.937 0 0 0 1.46.93.928.928 0 0 0 .38-.606l.82-4.683v.007s.203-1.27.683-1.27h.121c.489 0 .684 1.27.684 1.27v-.004l.82 4.684a.935.935 0 0 0 1.84-.328l-1.187-6.727-.192-1.16c-.113-.707-.164-1.86.02-2.332.156-.406.552-.555.906-.555h3.61a.937.937 0 0 0 0-1.875H3.438a.937.937 0 1 0 0 1.875H7.05c.36 0 .75.149.906.555.184.473.133 1.625.02 2.332l-.192 1.16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff"
  })))));
};
export { SvgAvatar as ReactComponent };